import { render } from "./PocoesDePesca.vue?vue&type=template&id=1ad9a6ee&scoped=true"
import script from "./PocoesDePesca.vue?vue&type=script&lang=js"
export * from "./PocoesDePesca.vue?vue&type=script&lang=js"

import "./PocoesDePesca.vue?vue&type=style&index=0&id=1ad9a6ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad9a6ee"]])

export default __exports__